var _defs, _g, _g2, _g3, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCopyLink = function SvgCopyLink(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.53 16.63",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".e{fill:#393939;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M15.55,6.71l-2.86-4.04c-.31-.44-.83-.71-1.37-.71H4.45c-.97,0-1.75,.79-1.75,1.75V14.84c0,.97,.79,1.75,1.75,1.75H14.1c.97,0,1.75-.79,1.75-1.75V7.68c0-.35-.11-.69-.31-.97Zm-1.62-.01h-1.55c-.22,0-.41-.18-.41-.41V3.94l1.95,2.76Zm.18,8.59H4.45c-.24,0-.44-.2-.44-.44V3.71c0-.24,.2-.44,.44-.44h6.21v3.01c0,.95,.77,1.72,1.72,1.72h2.16v6.83c0,.24-.2,.44-.44,.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M12.9,.69c0-.36-.29-.66-.66-.66H2.43C1.46,.03,.68,.82,.68,1.79V14.89c0,.36,.29,.66,.66,.66s.66-.29,.66-.66V1.79c0-.24,.2-.44,.44-.44H12.24c.36,0,.66-.29,.66-.66Z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "d"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCopyLink);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "copy-link.7a1f5ba96fbca6e538008445ccef71ad.svg";